angular.module('impactx.themeworld').controller('ThemeWorldCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'BackService',
    'ToastService',
    '$context',
    'ThemeWorldService',
    '$config',
    '$mdTheming',
    '$mdDialog',
    '$redirect',
    'ProductSelectionService',
    'SearchService',
    'IndexQueueProgressService',
    'ToolbarService',
    ThemeWorldCtrl
]);

function ThemeWorldCtrl($scope, dataGen, $routeParams, TranslationService, BackService, ToastService, $context, ThemeWorldService,
                        $config, $mdTheming, $mdDialog, $redirect, ProductSelectionService, SearchService, IndexQueueProgressService, ToolbarService) {
    var self = this;
    self.searchTextTargetGroups = "";
    $scope.showColors = {value: false};
    $scope.hasActiveThemeWorld = $context.hasActiveThemeWorld;
    $scope.translatedDescription = null;
    dataGen.getData($scope, {vcatId: $routeParams.id}, "/themeworld/view").then(function () {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.catalog = TranslationService.get('themeWorld');
        $scope.trns.delete = TranslationService.get('delete');
        if (!$scope.data.theme) {
            $scope.data.theme = $scope.customThemes[0].name;
        }
        if ($routeParams.activate) {
            ThemeWorldService.deactivateActiveThemeWorldSearch(true).then(function () {
                ThemeWorldService.activateThemeWorld($routeParams.id);
            });
        }

        angular.copy($scope.data.products, ThemeWorldService.validProducts);
        angular.copy($scope.data.lots, ThemeWorldService.lotFilter);

        IndexQueueProgressService.init().then(function () {
            IndexQueueProgressService.send({vcatName: $scope.data.name.value});
        });

        var descriptions = $scope.data.translatedDescription;
        $scope.translatedDescription = (descriptions && descriptions.length) ? descriptions[0] : null;

        defineButtons();
    });

    self.save = function (event) {
        if ($scope.data.needsCompanyDecision) {
            $mdDialog.show({
                controller: "ThemeWorldOwningCompanyCtrl",
                controllerAs: "themeWorldOwningCompanyCtrl",
                templateUrl: "modules/themeworld/templates/owningcompanydecision.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    title: $scope.trns.owningCompanyTitle,
                    data: $scope.data
                }
            }).then(function () {
                return self.doSave();
            }, function () {
            });
        }
        else {
            return self.doSave();
        }
    };

    self.doSave = function () {
        delete $scope.data.products;
        return dataGen.postAsForm($scope, {vcat: $scope.data}, "/themeworld/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            self.deactivateActiveThemeWorld();
            BackService.back();
        });
    };

    self.delete = function () {
        var ids = [];
        ids.push($scope.data.id);
        return dataGen.postAsForm({}, {ids: ids}, "/themeworld/delete").then(function (data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                if (data.trns.vcatDeactivated) {
                    ToastService.openStandardToast(data.trns.vcatDeactivated);
                }
            });
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    self.deactivateActiveThemeWorld = function () {
        ThemeWorldService.deactivateActiveThemeWorld().then(function (data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                if (data) {
                    ToastService.openStandardToast(data.trns.vcatDeactivated);
                }
            });
        });
    };

    $scope.$watch(function () {
            return IndexQueueProgressService.getLastMessage();
        },
        function (newValue) {
            $scope.$applyAsync(function () {
                if (newValue) {
                    var indexInProgress = newValue.value;

                    if ($scope.indexInProgress && !indexInProgress) {
                        $redirect.reload();
                    }
                    else {
                        $scope.indexInProgress = indexInProgress;
                    }
                }
            })
        }
    );

    $scope.customThemes = [];
    $scope.customThemeMap = {};
    var i = 0;
    while (i < $config.customThemes.length) {
        var name = $config.customThemes[i];
        var color = $mdTheming.PALETTES[name][500].hex;
        $scope.customThemes.push({name: name, color: color});
        $scope.customThemeMap[name] = color;
        i++;
    }

    self.setTheme = function (theme) {
        $scope.data.theme = theme;
        self.resetColorRow();
    };

    $scope.showColors = function () {
        $scope.showColors.value = true;
        $(".possible-color-choose").animate({
            marginRight: '16px'
        }, 500);
    };

    self.resetColorRow = function () {
        $scope.showColors.value = false;
        $(".possible-color-choose").animate({
            marginRight: '-50px'
        }, 500);
    };

    var hideColorPickerEvent = function (event) {
        if ($(event.target).closest('.color-choose').length === 0) {
            self.resetColorRow();
            $scope.$evalAsync();
        }
    };
    $(document).on('click', hideColorPickerEvent);

    $scope.$on("$destroy", function () {
        $(document).unbind('click', hideColorPickerEvent);
        IndexQueueProgressService.close();
    });

    self.viewValidProducts = function () {
        var config = {
            title: $scope.trns.products,
            locals: {
                hideDefaultAction: true,
                vcat: {id: $scope.data.id},
                itemActions: [{
                    action: self.removeProduct,
                    label: $scope.trns.remove,
                    reloadAfter: true
                }],
                listActions: [{
                    action: self.removeAllProducts,
                    label: $scope.trns.removeAll,
                    closeAfter: true
                }],
                forProductView: true
            }
        };
        ProductSelectionService.open(config).then(function () {
            $redirect.reload();
        });
    };

    self.viewInvalidProducts = function () {
        // the configured controller has special handling for actions,
        // so no need to provide anything other than the label
        // also hideDefaultAction and hideFilter are always true in this controller
        var config = {
            title: $scope.trns.invalidProducts,
            locals: {
                vcat: {id: $scope.data.id},
                itemActions: [{
                    label: $scope.trns.remove
                }],
                listActions: [{
                    label: $scope.trns.removeAll
                }],
                forProductView: true
            },
            controller: 'ThemeWorldInvalidProductsCtrl'
        };
        ProductSelectionService.open(config).then(function () {
            $redirect.reload();
        });
    };

    self.removeProduct = function (product, index) {
        return ThemeWorldService.removeProductsFromThemeWorld($scope.data.id, [product.id]).then(function () {
            SearchService.consumableTopIndexOtherProductSearch.value = index;
        });
    };

    self.removeAllProducts = function () {
        return dataGen.postAsForm({}, {vcatId: $scope.data.id}, "/themeworld/remove/product/allValid").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: isEditable
            },
            {
                label: $scope.trns.addElements,
                linkFunction: getSearchLink,
                type: 'link',
                condition: canAddProducts
            }
        ];
        ToolbarService.backButtonCallback(self.deactivateActiveThemeWorld);
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return $scope.data.id > 0;
    }

    function getSearchLink() {
        return "search";
    }

    function canAddProducts() {
        return isEditable() && $scope.hasActiveThemeWorld.id === $scope.data.id;
    }

    $scope.tinymceOptions = $config.tinymceOptions;

    self.changeDescriptionByLanguage = function (language) {
        $scope.translatedDescription = $scope.data.translatedDescription.find(function (item) {
            return item.languageCode === language;
        })
        $scope.$applyAsync();
    }
}